import { BaseList, BaseDetail } from "App/Component/Bases";
import fields from "./fields";
import ComponentAutocomplete from "App/Component/Autocomplete";
import descriptor from "./descriptor";
import options from "./options";

const title = "Merchant Groups";
const urlData = "merchantGroups";
const bulkName = "name";
const children = {
    appName: 'jobs',
    modelName: 'merchant',
    name: 'merchantGroups',
    sub: 'merchants',
    dataIndex: 'merchants',
    identifier: {
      name: 'merchant_group',
      is_array: false
    },
    bulk_request: true,
    urlSub: 'api:admin:jobs:merchantgroup:ref-merchants-list',
    add: true,
    edit: true,
    data: false,
    permissions: {
      bulk_delete: false,
      initialrow: 1,
      payload: true,
      add: true
    },
    rules: {
      button: {
        type: {
          add: 'default',
          edit: 'default'
        },
        size: 'small'
      },
      input: {
        size: 'small'
      },
      select: {
        size: 'small'
      }
    },
  form_rules: {
      must_sent: [
        {
          name: 'branch',
          default_value: null
        },
        {
          name:'operating_branch',
          default_value: null
        },
        {
          name: 'extra_charge',
          default_value: null
        }],
  },
  fields: ComponentAutocomplete['merchants']
  }

class List extends BaseList {
  constructor(props) {
    super(props)

    this.title = title;
    this.urlData = urlData;
    this.bulkName = bulkName;
    this.propsList = {
      descriptor,
      exportImport: options.exportImportOptions,
    }
  }
}

class Detail extends BaseDetail {
  constructor(props) {
    super(props)

    this.title = title
    this.urlData = urlData
    this.bulkName = bulkName
    this.fields = fields
    this.children = children
    this.propsDetail = {
      urlKeyHistory: 'api:admin:jobs:merchantgroup:detail-revision',
      keyLabel: 'name'
    }
  }
}

export default { List, Detail };
